/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiRerunScenariosForTransactionsByIdsRequest
 */
export interface InternalApiRerunScenariosForTransactionsByIdsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiRerunScenariosForTransactionsByIdsRequest
     */
    scenarioHandles: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof InternalApiRerunScenariosForTransactionsByIdsRequest
     */
    transactionIds: Array<number>;
}

/**
 * Check if a given object implements the InternalApiRerunScenariosForTransactionsByIdsRequest interface.
 */
export function instanceOfInternalApiRerunScenariosForTransactionsByIdsRequest(value: object): value is InternalApiRerunScenariosForTransactionsByIdsRequest {
    if (!('scenarioHandles' in value) || value['scenarioHandles'] === undefined) return false;
    if (!('transactionIds' in value) || value['transactionIds'] === undefined) return false;
    return true;
}

export function InternalApiRerunScenariosForTransactionsByIdsRequestFromJSON(json: any): InternalApiRerunScenariosForTransactionsByIdsRequest {
    return InternalApiRerunScenariosForTransactionsByIdsRequestFromJSONTyped(json, false);
}

export function InternalApiRerunScenariosForTransactionsByIdsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiRerunScenariosForTransactionsByIdsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'scenarioHandles': json['scenarioHandles'],
        'transactionIds': json['transactionIds'],
    };
}

export function InternalApiRerunScenariosForTransactionsByIdsRequestToJSON(json: any): InternalApiRerunScenariosForTransactionsByIdsRequest {
    return InternalApiRerunScenariosForTransactionsByIdsRequestToJSONTyped(json, false);
}

export function InternalApiRerunScenariosForTransactionsByIdsRequestToJSONTyped(value?: InternalApiRerunScenariosForTransactionsByIdsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scenarioHandles': value['scenarioHandles'],
        'transactionIds': value['transactionIds'],
    };
}

